export const FORM_EDITOR_GET_PREFILLED_FORM_START = 'FORM_EDITOR_GET_PREFILLED_FORM_START';
export const FORM_EDITOR_GET_PREFILLED_FORM_SUCCESS = 'FORM_EDITOR_GET_PREFILLED_FORM_SUCCESS';
export const FORM_EDITOR_GET_PREFILLED_FORM_FAIL = 'FORM_EDITOR_GET_PREFILLED_FORM_FAIL';

export const FORM_EDITOR_SAVE_PDF_FORM_START = 'FORM_EDITOR_SAVE_PDF_FORM_START';
export const FORM_EDITOR_SAVE_PDF_FORM_SUCCESS = 'FORM_EDITOR_SAVE_PDF_FORM_SUCCESS';
export const FORM_EDITOR_SAVE_PDF_FORM_FAIL = 'FORM_EDITOR_SAVE_PDF_FORM_FAIL';

export const FORM_EDITOR_GET_FORM_PARAMETERS_START = 'FORM_EDITOR_GET_FORM_PARAMETERS_START';
export const FORM_EDITOR_GET_FORM_PARAMETERS_SUCCESS = 'FORM_EDITOR_GET_FORM_PARAMETERS_SUCCESS';
export const FORM_EDITOR_GET_FORM_PARAMETERS_FAIL = 'FORM_EDITOR_GET_FORM_PARAMETERS_FAIL';

export const FORM_EDITOR_GET_POLICIES_BY_IDS_START = 'FORM_EDITOR_GET_POLICIES_BY_IDS_START';
export const FORM_EDITOR_GET_POLICIES_BY_IDS_SUCCESS = 'FORM_EDITOR_GET_POLICIES_BY_IDS_SUCCESS';
export const FORM_EDITOR_GET_POLICIES_BY_IDS_FAIL = 'FORM_EDITOR_GET_POLICIES_BY_IDS_FAIL';

export const FORM_EDITOR_GET_ACORD_LOOKUP_START = 'FORM_EDITOR_GET_ACORD_LOOKUP_START';
export const FORM_EDITOR_GET_ACORD_LOOKUP_SUCCESS = 'FORM_EDITOR_GET_ACORD_LOOKUP_SUCCESS';
export const FORM_EDITOR_GET_ACORD_LOOKUP_FAIL = 'FORM_EDITOR_GET_ACORD_LOOKUP_FAIL';
